module.exports = __webpack_public_path__ + "static/media/tournament.ce5f4005.svg";